import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const AnchorWrapper = styled(Link)`
  color: inherit;

  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;
